module.exports = "/_next/static/images/DeletionRequests-36fe321ec844ce8d1d7d178b03f3ea8e.webp";